
import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo1.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";




    

export const resetAdminError = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_ADMIN_ERROR" });
    };
};

export const resetEditUserOverlay = () => {
    return (dispatch) => {
        dispatch({ type: "EDIT_USER_OVERLAY", user_id: null });
    };
};

export const editUserOverlay = (user_id) => {
    return (dispatch) => {
        dispatch({ type: "EDIT_USER_OVERLAY", user_id: user_id });
    };
};


export const updateUser = (user) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/admin/update_user/", user)
            .then(({ data }) => {
                dispatch({ type: "ADMIN_USERS_UPDATED", users: data });
            });
    };
};

export const createUser = (user) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/admin/create_user/", user)
            .then(({ data }) => {
                dispatch({ type: "ADMIN_USERS_CREATED", users: data });
            }).catch((error) => {
                ////console.log(error);
                dispatch({ type: "ADMIN_ERROR", error: error.response.data.error });
            });
    };
};

export const getUsers = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/admin/get_users/")
            .then(({ data }) => {
                dispatch({ type: "ADMIN_USERS", users: data });
            });
    };
};

export const suspendUser = (user_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/admin/suspend_user/", { user_id: user_id })
            .then(({ data }) => {
                dispatch({ type: "ADMIN_USERS", users: data });
            });
    };
};